import { useCallback } from 'react';

import { fetchStories, fetchStoryById } from '../../../services/api/stories';
import { AsyncSelect, type AsyncSelectProps } from '../AsyncSelect/AsyncSelect';

import type { CnpStory } from '../../../types';
import type { FC } from 'react';

type Props = Omit<
  AsyncSelectProps<CnpStory>,
  'fetchMany' | 'fetchOne' | 'mapItemToOption'
>;

const StoriesSelect: FC<Props> = (props) => {
  const mapItemToOption = useCallback(
    ({ id, title }: { id: string | number; title: string }) => ({
      value: id.toString(),
      label: title,
    }),
    []
  );

  const searchStories = useCallback(
    (query: string) => fetchStories({ query }),
    []
  );

  return (
    <AsyncSelect
      fetchMany={searchStories}
      fetchOne={fetchStoryById}
      mapItemToOption={mapItemToOption}
      {...props}
    />
  );
};

export { StoriesSelect };
